"use client";

import { Construction, Truck, Wrench } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const equipmentTypes = [{
  id: 1,
  title: "Camiones",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/trucks_heavy_duty_fleet.png",
  icon: Truck,
  path: "/Trucks"
}, {
  id: 2,
  title: "Máquinas",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/heavy_machinery_excavator.png",
  icon: Construction,
  path: "/Heavy Machinery"
}, {
  id: 3,
  title: "Equipos",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/low_bed_trailer_machinery_transport.png",
  icon: Wrench,
  path: "/equipment"
}];
export default function ExploreByEquipmentType() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center font-display text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
          Explorar por Tipo de Equipo
        </h2>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {equipmentTypes.map((equipment, i) => {
          const Icon = equipment.icon;
          return <div key={equipment.id} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-slow)] ${visibilities[i] ? "translate-x-0 opacity-100" : "-translate-x-16 opacity-0"}`}>
                <Link to={equipment.path} className="block">
                  <Card className="group relative h-full cursor-pointer overflow-hidden border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:rotate-[2deg] hover:shadow-strong">
                    <div className="relative aspect-[4/3] w-full overflow-hidden">
                      <img src={equipment.image} alt={equipment.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-110" />
                      <div className={`absolute inset-0 flex items-center justify-center backdrop-blur-[2px] transition-all duration-[var(--duration-medium)] ${i === 0 || i === 2 ? "bg-yellow-500/70 group-hover:bg-yellow-500/80" : "bg-primary/60 group-hover:bg-primary/70"}`}>
                        <Icon className="h-20 w-20 text-slate-900 drop-shadow-lg transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-110" />
                      </div>
                    </div>
                    <div className="p-6">
                      <h3 className="text-center font-display text-xl font-semibold text-foreground">
                        {equipment.title}
                      </h3>
                    </div>
                  </Card>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}